import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Icon, Link } from 'xm-spark';

import useFeatureToggle from 'hooks/useFeatureToggle';
import SadRobot from 'resources/svg/blippi/sad.svg';
import SadRobotEverbridge from 'resources/svg/blippi/sad-everbridge.svg';
import styles from './HelpViewPageError.module.scss';

export default function HelpViewPageError({ className, linkHref }) {
  const enableEverbridgeBranding = useFeatureToggle(
    'ENABLE_EB_PRODUCT_BRANDING',
  );
  return (
    <div className={className} data-testid="HelpView_error">
      <header className={styles.header}>
        <FormattedMessage id="HELP_MENU_ERROR_HEAD" />
      </header>
      <div className={styles.image}>
        {enableEverbridgeBranding ? <SadRobotEverbridge /> : <SadRobot />}
      </div>
      <div className={styles.body}>
        <FormattedMessage id="HELP_MENU_ERROR_BODY" />
      </div>
      <Link
        className={styles.link}
        data-testid="HelpView_error_resetButton"
        href={linkHref}
        target="_blank"
        rel="noopener noreferrer"
      >
        <FormattedMessage id="HELP_MENU_ERROR_ACTION" />
        <Icon className={styles.linkIcon} type="icon-link-widget" />
      </Link>
    </div>
  );
}

HelpViewPageError.displayName = 'HelpViewPageError';
HelpViewPageError.propTypes = {
  className: PropTypes.string.isRequired,
  linkHref: PropTypes.string.isRequired,
};
